var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"art-grid"},_vm._l((_vm.artImages),function(imageGroup,index){return _c('img',{key:("art-image-" + index),staticClass:"art-image",attrs:{"v-lazy":_vm.srcSet('src', imageGroup),"srcset":_vm.srcSet('srcset', imageGroup)}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4098d3b0","hasScoped":true,"transformToRequire":{"svg-component":"src","video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--1-1!./app/src/components/ArtGrid.vue
// module id = null
// module chunks = 